import { withRouter } from "react-router-dom";
import * as _ from "lodash";
import MainContent from "../../boxes/MainContent";
import PageHeader from "../../boxes/PageHeader";
import PageBody from "../../boxes/PageBody";
import { useTranslation } from "react-i18next";
import LoadingScreen from "../../LoadingScreen";

const checkSuccessCircle = "/img/care-balance/check-success-circle.svg";

function RefundRequestSubmittedContainer(props) {
  const { user } = props;

  const { t } = useTranslation("careBalance");

  if (_.isEmpty(user?.hmoId)) {
    return <LoadingScreen />;
  }

  return (
    <>
      <MainContent>
        <PageHeader title={t("requestRefundTitle")} />

        <PageBody
          style={{
            gap: "8px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="dashboard-card"
            style={{
              display: "flex",
              flexDirection: "column",
              rowGap: "16px",
              alignItems: "center",
            }}
          >
            <img
              src={checkSuccessCircle}
              style={{
                width: "64px",
                height: "64px",
              }}
            />

            <h2
              style={{
                fontWeight: 700,
                fontSize: "2.4rem",
                color: "#094063",
                lineHeight: "100%",
              }}
            >
              Refund Request Submitted
            </h2>

            <p
              style={{
                fontSize: "1.6rem",
                color: "#094063",
              }}
            >
              Your refund request will be processed within 2 weeks
            </p>

            <button
              style={{
                borderRadius: "128px",
                paddingBlock: "16px",
                paddingInline: "24px",
                backgroundColor: "#094063",
                color: "#ffffff",
                fontSize: "1.5rem",
                fontWeight: 600,
                lineHeight: "22px",
                letterSpacing: "0%",
              }}
              onClick={() => {
                props.history.push("/");
              }}
              data-testid="fund-success-button"
            >
              {t("fundSuccessButtonLabel")}
            </button>
          </div>
        </PageBody>
      </MainContent>
    </>
  );
}

export default withRouter(RefundRequestSubmittedContainer);
